/**************************************/
/****** SHOW UPSELL
/**************************************/
$(document).on('click', '.cart__checkout, .lm-go-checkout', function () {
  	var _this = this;
  	$(_this).addClass('btn--loading');
  	setTimeout(function() {
    	$(_this).removeClass('btn--loading');
  	}, 3 * 1000);
    
  	var hasProduct = $(".lm-cart li.lm-cart-item[data-product-id='32764891955282']").length > 0;  	  	
    if(!hasProduct) {
      localStorage.setItem("lm-upsell", true);      
      $('#lm-upsell').css('visibility', 'visible').hide().fadeIn(250);
      $('body').addClass('lm-fixed');
      return false;
    } else {
      window.location.href = '/checkout';	
    }    
});

window.addEventListener('popstate', (event) => {
  $('.btn[name="checkout"]').removeClass('btn--loading');
  $('#lm-upsell').hide();
  $('body').removeClass('lm-fixed');  
});

/**************************************/
/****** CLOSE UPSELL
/**************************************/

$(document).on('click', '#lm-upsell .lm-upsell-close', function () {
  if($(this).hasClass('close')) {
     $(this).addClass('btn--loading');
  } else {
	 $('#lm-upsell').fadeOut(0);
  	 $('body').removeClass('lm-fixed');
  }
  window.location.href = '/checkout';
});

/**************************************/
/****** ADD PRODUCT TO CART
/**************************************/

$(document).on('click', '#lm-upsell #lm-upsell-add', function () {
  $(this).addClass('btn--loading');  
  var cartItems = [{
    id: "32764891955282",
    quantity: 1,
  }];
  
  
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      items: cartItems,
    },
    dataType: 'json',
    success: function (data) {
      window.location.href = '/checkout';
    },
    error: function (data) {
      console.log(data);
    },
  });
});
